import services from "../services";
import {billerCrossReferenceService} from "../services/billerCrossReference.service";

export const billerCrossReferenceActions = {
    searchBillerCrossReference,
};

function searchBillerCrossReference(values, props) {
    return services.billerCrossReferenceService.searchBillerCrossReference(values, props);
}

